// Copyright (c) 2020 WiseTime. All rights reserved.

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file wisetime/type/data_retention.proto (package wisetime.type, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file wisetime/type/data_retention.proto.
 */
export const file_wisetime_type_data_retention: GenFile = /*@__PURE__*/
  fileDesc("CiJ3aXNldGltZS90eXBlL2RhdGFfcmV0ZW50aW9uLnByb3RvEg13aXNldGltZS50eXBlKtQBChNEYXRhUmV0ZW50aW9uUGVyaW9kEiUKIURBVEFfUkVURU5USU9OX1BFUklPRF9VTlNQRUNJRklFRBAAEhEKDUZPVVJURUVOX0RBWVMQARIOCgpTRVZFTl9EQVlTEAISEwoPVFdFTlRZX09ORV9EQVlTEAMSDQoJT05FX01PTlRIEAQSEAoMVEhSRUVfTU9OVEhTEAUSDgoKU0lYX01PTlRIUxAGEgwKCE9ORV9ZRUFSEAcSDQoJVFdPX1lFQVJTEAgSEAoMTUFYX0VMSUdJQkxFEAlCLQoVY29tLndpc2V0aW1lLmFwaS50eXBlQhJEYXRhUmV0ZW50aW9uUHJvdG9QAWIGcHJvdG8z");

/**
 * @generated from enum wisetime.type.DataRetentionPeriod
 */
export enum DataRetentionPeriod {
  /**
   * @generated from enum value: DATA_RETENTION_PERIOD_UNSPECIFIED = 0;
   */
  DATA_RETENTION_PERIOD_UNSPECIFIED = 0,

  /**
   * @generated from enum value: FOURTEEN_DAYS = 1;
   */
  FOURTEEN_DAYS = 1,

  /**
   * @generated from enum value: SEVEN_DAYS = 2;
   */
  SEVEN_DAYS = 2,

  /**
   * @generated from enum value: TWENTY_ONE_DAYS = 3;
   */
  TWENTY_ONE_DAYS = 3,

  /**
   * @generated from enum value: ONE_MONTH = 4;
   */
  ONE_MONTH = 4,

  /**
   * @generated from enum value: THREE_MONTHS = 5;
   */
  THREE_MONTHS = 5,

  /**
   * @generated from enum value: SIX_MONTHS = 6;
   */
  SIX_MONTHS = 6,

  /**
   * @generated from enum value: ONE_YEAR = 7;
   */
  ONE_YEAR = 7,

  /**
   * @generated from enum value: TWO_YEARS = 8;
   */
  TWO_YEARS = 8,

  /**
   * presudo period assigned to user, that is resolved to max allowed based on user's memberships.
   *
   * @generated from enum value: MAX_ELIGIBLE = 9;
   */
  MAX_ELIGIBLE = 9,
}

/**
 * Describes the enum wisetime.type.DataRetentionPeriod.
 */
export const DataRetentionPeriodSchema: GenEnum<DataRetentionPeriod> = /*@__PURE__*/
  enumDesc(file_wisetime_type_data_retention, 0);

